module.exports = __webpack_public_path__ + "media/marketing_campaigns/recipient_list-d620ed78.svg";